// extracted by mini-css-extract-plugin
export default {"button":"zl-z","reviewSort":"Al-z"};